// @flow
import React from 'react';

import styles from './RowLayout.module.scss';;


const Space = () => (
  <div className={styles.space} />
);

export default Space;
